import type { IconDef } from '../types';

export const calendar: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M19 2.5H18.58V1C18.58 0.45 18.13 0 17.58 0C17.03 0 16.58 0.45 16.58 1V2.5H7.19V1C7.19 0.45 6.74 0 6.19 0C5.64 0 5.19 0.45 5.19 1V2.5H5C2.24 2.5 0 4.74 0 7.5V19.25C0 22.01 2.24 24.25 5 24.25H19C21.76 24.25 24 22.01 24 19.25V7.5C24 4.74 21.76 2.5 19 2.5ZM5.19 4.21V6.4C5.19 6.95 5.64 7.4 6.19 7.4C6.74 7.4 7.19 6.95 7.19 6.4V4.28L16.58 4.69V6.4C16.58 6.95 17.03 7.4 17.58 7.4C18.13 7.4 18.58 6.95 18.58 6.4V4.78L19.38 4.81C21.03 4.88 22.32 6.29 22.25 7.94L22.17 9.74H2.15L2.27 7.07C2.34 5.49 3.63 4.25 5.2 4.22L5.19 4.21ZM18.61 22.55L4.62 21.94C2.97 21.87 1.68 20.46 1.75 18.81L2.06 11.74H22.08L21.73 19.68C21.66 21.33 20.25 22.62 18.6 22.55H18.61Z',
    },
  ],
};
